import { OrderHeadersGroupBy, OrderHeadersGroupByEnum } from '../../orderProducts.types';
import OrderProductsBuilder from './OrderProductsSorterBuilder';
import OrderProductsSorterByColorClassifications from './OrderProductsSorterByColorClassifications';
import OrderProductsSorterCategory from './OrderProductsSorterCategory';
import OrderProductsSorterCollection from './OrderProductsSorterCollection';
import OrderProductsSorterDefault from './OrderProductsSorterDefault';
import OrderProductsSorterDeliveryWindow from './OrderProductsSorterDeliveryWindow';
import OrderProductsSorterPendency from './OrderProductsSorterPendency';
import OrderProductsSorterProduct from './OrderProductsSorterProduct';
import OrderProductsSorterSubCategory from './OrderProductsSorterSubCategory';

class OrderProductsSorterFactory {
  create(view: OrderHeadersGroupBy[]): OrderProductsBuilder {
    switch (view[0]) {
      case OrderHeadersGroupByEnum.DELIVERY_WINDOW:
        return new OrderProductsSorterDeliveryWindow();
      case OrderHeadersGroupByEnum.COLLECTION:
        return new OrderProductsSorterCollection();
      case OrderHeadersGroupByEnum.CATEGORY:
        return new OrderProductsSorterCategory();
      case OrderHeadersGroupByEnum.SUB_CATEGORY:
        return new OrderProductsSorterSubCategory();
      case OrderHeadersGroupByEnum.PRODUCT:
        return new OrderProductsSorterProduct();
      case OrderHeadersGroupByEnum.PENDENCY:
        return new OrderProductsSorterPendency();
      case OrderHeadersGroupByEnum.COLOR_CLASSIFICATION_TYPE:
        return new OrderProductsSorterByColorClassifications();
      default:
        return new OrderProductsSorterDefault();
    }
  }
}

export default OrderProductsSorterFactory;
